module.exports = __webpack_public_path__ + "img/3.e2201412.png";